export const LABELS = {
  NAME: "Name",
  AREA: "Area",
  ADDRESS_LINE_1: "Address Line 1",
  // ADDRESS_LINE_2: "Address Line 2",
  CITY: "City",
  STATE: "State",
  PINCODE: "Pincode",
  CONTACT_NUMBER: "Contact Number",
  EMAIL_ADDRESS: "Email Address",
  DOB: "Date of joining",
};

export const NEW_ENTRY_FIELDS = {
  NAME: "fullName",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  PARENT_EMAIL_ADDRESS: "parentsEmailId",
  PARENT_CONTACT_NUMBER: "parentsMobileNumber",
  DIVISION: "divisionId",
  SUB_DIVISION: "subdivisionId",
  GENDER: "gender",
  NATIONALITY_ID: "nationalityId",
  DATE_OF_JOINING: "dateOfJoining",
  INTRODUCED_BY_NAME: "introducerName",
  INTRODUCED_BY_EMAIL: "introducerEmail",
  INTRODUCED_BY_MOBILE_NUMBER: "introducerMobileNumber",
  INTRODUCED_BY: "introducedBy",
  COUNTRY: "countryId",
  POSITION: "positions",
};

export const NEW_FRIEND_FIELDS = {
  NAME: "fullName",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  DIVISION: "divisionId",
  SUB_DIVISION: "subdivisionId",
  NATIONALITY_ID: "nationalityId",
  INTRODUCED_BY_NAME: "introducerName",
  INTRODUCED_BY_EMAIL: "introducerEmail",
  INTRODUCED_BY_MOBILE_NUMBER: "introducerMobileNumber",
  DATE_OF_BIRTH: "dateOfBirth",
  PROFESSION: "profession",
  COUNTRY: "countryId",
};

export const FRIEND_TRANFER_REQUEST_FIELDS = {
  FRIEND_NAME: "firendName",
  FRIEND_ID: "firendId",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  DIVISION: "divisionId",
  SUB_DIVISION: "subdivisionId",
  DATE_OF_JOINING: "dateOfJoining",
};

export const ORGANIZATION_STRUCTURE_FIELDS = {
  AREA: "areaId",
  CLUSTER: "clusterId",
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  DISTRICT: "districtId",
  BLOCK: "blockId",
  ADDRESS: "address",
};

export const FORGOT_PASSWORD_FIELDS = {
  NEW_PASSWORD: "newPassword",
  CONFIRM_PASSWORD: "confirmPassword",
};

export const validations = () => {};
